import Head from "next/head";
import dynamic from "next/dynamic";
import { maxString } from "../../js/config/helpers";
import { handleRateLimit } from "utils/handleRateLimit";
import { getClientIp } from "utils/requestHelpers";

const ShowcaseLayout = dynamic(() => import("../../js/Components/Showcase/ShowcaseLayout"));

const index = ({ data }) => {

    const {
        place
    } = data;

    return (
        <>
            <Head>
                <title>{`Our Gallery - Page ${data.showcase.current_page} - ${process.env.brand.brand_name}`}</title>
                <meta
                    name="description"
                    content={`${process.env.brand.brand_name} photo gallery for our clients. Our product range includes chairs to hire, conference furniture tables to hire, exhibition furniture hire, and office furntiture hire`}
                />
            </Head>
            <ShowcaseLayout {...data} />
        </>
    );
};

export async function getServerSideProps({ req, res, query }) {
    const { slug } = query;
    const { headers } = getClientIp(req);

    try {
        const page = !query.page ? 1 : query.page;
        const apiReq = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}showcase/${slug}?type=gallery&page=${page}`, { headers });

        let data = null;

        try {
            data = await apiReq.json();
        } catch (error) {
            console.error('Invalid API response:', error);
        }

        const rateLimitRedirect = handleRateLimit(res, apiReq, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if (!data || data?.exception) {
            return { notFound: true }
        }

        return {
            props: {
                data
            }
        };

    } catch (error) {
        return { notFound: true }
    }
}


export default index;
